import { borders, spacing, typography } from '~tokens/internal'

export const proseLinkStyles = {
  cursor: 'pointer',
  fontWeight: typography.fontWeight.bold,
  textDecoration: 'underline',
  textDecorationThickness: borders.width.thin,
  textUnderlineOffset: spacing.pico,
  '&:hover': {
    textDecorationThickness: borders.width.medium,
  },
} as const
